(() => {
  const preventSubmission = (e) => {
    e.preventDefault();
  };
  window.preventSubmission = preventSubmission;
})();
